export const UNASSIGNED_EPIC_ID = '0' as const;
export const DEFAULT_PARENT_ISSUE_TYPE_NAME = 'Epic' as const;
export const DEFAULT_CHILD_ISSUE_TYPE_NAME = 'Subtask' as const;
